module.exports = __webpack_public_path__ + "img/visa.eeb186a2.svg";